import { OrderItem } from '@libs/api-reference';

import {
  LEGACY_ORDER_PENDING_STATUSES,
  LEGACY_ORDER_STATUSES_GROUPS,
  NEW_OMS_ORDER_PENDING_STATUSES,
  NEW_OMS_ORDER_STATUSES_GROUPS,
} from '../constants';
import { isNewOms } from '../composables/useGetOmsStatusQuery';

const isOpenOrder = (order: OrderItem, isNew = isNewOms.value) => {
  return isNew
    ? NEW_OMS_ORDER_STATUSES_GROUPS.open.includes(order.orderStateId)
    : LEGACY_ORDER_STATUSES_GROUPS.open.includes(order.orderStateId);
};

const isPendingOrder = (order: OrderItem, isNew = isNewOms.value) => {
  return Object.values(
    isNew ? NEW_OMS_ORDER_PENDING_STATUSES : LEGACY_ORDER_PENDING_STATUSES
  ).includes(order.orderStateId);
};

const isDoneOrder = (order: OrderItem, isNew = isNewOms.value) => {
  return isNew
    ? NEW_OMS_ORDER_STATUSES_GROUPS.done.includes(order.orderStateId)
    : LEGACY_ORDER_STATUSES_GROUPS.done.includes(order.orderStateId);
};

const isDeletableOrder = (order: OrderItem, isFromHistory: boolean) => {
  if (isFromHistory) return false;

  if ('newOrderState' in order) {
    return isOpenOrder(order, Boolean(order.newOrderState));
  }

  return isOpenOrder(order);
};

export { isOpenOrder, isPendingOrder, isDoneOrder, isDeletableOrder };
